(function () {
  var GROUPS = [
    {
      products: [
        { handle: 'lampe-de-chevet-scandinave-orange', name: 'Solvik', color: '#B43F00' },
        { handle: 'lampe-de-chevet-scandinave-bleue', name: 'Havet', color: '#232B45' },
        { handle: 'lampe-de-chevet-scandinave-grise', name: 'Grano', color: '#5D5B57' }
      ]
    },
    {
      products: [
        { handle: 'lampe-de-chevet-retro-pied-argente-dome-orange-verre', name: 'Zafferano', color: '#DD6B1F' },
        { handle: 'lampe-de-chevet-retro-pied-argente-dome-jaune-creme-verre', name: 'Vaniglia', color: '#EFDD9E' },
        { handle: 'lampe-de-chevet-retro-pied-argent-dome-rose-verre', name: 'Petalo', color: '#F0B7C2' },
        { handle: 'lampe-de-chevet-retro-pied-argent-dome-blanche-verre', name: 'Bianca', color: '#FAFAF7' },
        { handle: 'lampe-de-chevet-retro-sur-pied-argente-dome-rouge-verre', name: 'Scarlatta', color: '#C42A22' }
      ]
    },
    {
      products: [
        { handle: 'lampe-de-chevet-vintage-plissee-orange-et-blanche', name: 'Terracotta', color: '#D9A233' },
        { handle: 'lampe-de-chevet-vintage-plissee-rose', name: 'Cipria', color: '#F0B8C0' },
        { handle: 'lampe-de-chevet-vintage-plissee-verte', name: 'Salvia', color: '#1F6B52' },
        { handle: 'lampe-de-chevet-vintage-plissee-creme', name: 'Panna', color: '#EFDD9E' },
        { handle: 'lampe-de-chevet-vintage-plisse-blanche', name: 'Avorio', color: '#F7F3EA' }
      ]
    },
    {
      products: [
        { handle: 'lampe-de-chevet-macaron-blanche', name: 'Neve', color: '#FAFAF7' },
        { handle: 'lampe-de-chevet-macaron-jaune', name: 'Citra', color: '#EFE1A0' },
        { handle: 'lampe-de-chevet-macaron-rose', name: 'Fiora', color: '#F1A9C1' },
        { handle: 'lampe-de-chevet-macaron-orange', name: 'Ambra', color: '#E08A2E' }
      ]
    },
    {
      products: [
        { handle: 'lampe-de-chevet-en-verre-orange-retro', name: 'Mandarina', color: '#E07A1F' },
        { handle: 'lampe-de-chevet-en-verre-rouge-retro', name: 'Rubino', color: '#C6281F' },
        { handle: 'lampe-de-chevet-en-verre-blanche-retro', name: 'Candida', color: '#FAFAF7' },
        { handle: 'lampe-de-chevet-en-verre-jaune-retro', name: 'Solene', color: '#E8D9A0' },
        { handle: 'lampe-de-chevet-en-verre-rose-retro', name: 'Rosalia', color: '#DD8B9C' }
      ]
    },
    {
      products: [
        { handle: 'lampe-de-chevet-champignon-jaune-arrondie', name: 'Girasola', color: '#D4C13A' },
        { handle: 'lampe-de-chevet-champignon-rose-arrondie', name: 'Rosetta', color: '#D98B8A' },
        { handle: 'lampe-de-chevet-champignon-blanche-arrondie', name: 'Nuvoletta', color: '#F5F5F3' }
      ]
    },
    {
      products: [
        { handle: 'lampe-de-chevet-champignon-bubble-blanche', name: 'Perletta', color: '#FAFAF7' },
        { handle: 'lampe-de-chevet-champignon-bubble-jaune', name: 'Limona', color: '#E8C22E' },
        { handle: 'lampe-de-chevet-bubble-champignon-rose', name: 'Fragolina', color: '#EAA0AB' },
        { handle: 'lampe-de-chevet-bubble-champignon-rouge', name: 'Corallo', color: '#7A1F1F' }
      ]
    },
    {
      products: [
        { handle: 'lampe-de-chevet-champignon-rosy', name: 'Rosette', color: '#E38FA5' },
        { handle: 'lampe-de-chevet-champignon-blanca', name: 'Candeur', color: '#F5F3EE' },
        { handle: 'lampe-de-chevet-champignon-nectar', name: 'Nectra', color: '#E8D45A' },
        { handle: 'lampe-de-chevet-champignon-sunny', name: 'Sunna', color: '#E08A2E' }
      ]
    },
    {
      products: [
        { handle: 'lampe-de-chevet-champignon-tactile-en-verre-orange', name: 'Riga', color: '#E8742A' },
        { handle: 'lampe-de-chevet-champignon-tactile-en-verre-vert-pastel', name: 'Tallinn', color: '#A9C96B' },
        { handle: 'lampe-de-chevet-champignon-tactile-en-verre-jaune-pastel', name: 'Gdansk', color: '#EBD86A' },
        { handle: 'lampe-de-chevet-champignon-tactile-en-verre-rose-pastel', name: 'Krakow', color: '#E88FA6' }
      ]
    },
    {
      products: [
        { handle: 'lampe-de-chevet-silhouette', name: 'Ceresia', color: '#8C2020' },
        { handle: 'lampe-de-chevet-silhouette-noir', name: 'Notte', color: '#151515' },
        { handle: 'lampe-de-chevet-silhouette-bleue', name: 'Marina', color: '#1F4FA0' },
        { handle: 'lampe-de-chevet-silhouette-blanche', name: 'Perla', color: '#F5F5F3' }
      ]
    },
    {
      products: [
        { handle: 'lampe-de-chevet-moderne-doree', name: 'Miele', color: '#B9985A' },
        { handle: 'lampe-de-chevet-moderne-argentee', name: 'Perlato', color: '#B0B3B6' },
        { handle: 'lampe-de-chevet-moderne-doree-blanche', name: 'Aurora', color: '#C9A84C' }
      ]
    },
    {
      products: [
        { handle: 'lampe-de-chevet-moderne-rouge-cerise', name: 'Amarena', color: '#4A1420' },
        { handle: 'lampe-de-chevet-moderne-blanche', name: 'Lunetta', color: '#F5F3EE' }
      ]
    },
    {
      products: [
        { handle: 'lampe-de-chevet-boule-crystal-socle-bois-animal', name: 'Silvestra', color: '#8A6D3B', image: 'https://cdn.shopify.com/s/files/1/1050/4755/6445/files/ChatGPT_Image_11_sept._2026_21_36_25_3.webp?v=1789155776&width=120' },
        { handle: 'lampe-de-chevet-en-forme-de-boule-cristal-socle-bois-univers', name: 'Infinita', color: '#1B2A4A', image: 'https://cdn.shopify.com/s/files/1/1050/4755/6445/files/ChatGPT_Image_11_sept._2026_22_06_54_2.webp?v=1789157396&width=120' },
        { handle: 'lampe-de-chevet-boule-cristal-socle-bois-galaxy', name: 'Nebulosa', color: '#4B3272', image: 'https://cdn.shopify.com/s/files/1/1050/4755/6445/files/ChatGPT_Image_11_sept._2026_22_21_54.webp?v=1789159064&width=120' },
        { handle: 'lampe-de-chevet-boule-cristal-socle-bois-systeme-solaire', name: 'Cosmo', color: '#16324F', image: 'https://cdn.shopify.com/s/files/1/1050/4755/6445/files/ChatGPT_Image_11_sept._2026_22_56_26_1.webp?v=1789160449&width=120' },
        { handle: 'lampe-de-chevet-boule-cristal-socle-en-bois-lune', name: 'Lunaria', color: '#9C9C9C', image: 'https://cdn.shopify.com/s/files/1/1050/4755/6445/files/ChatGPT_Image_11_sept._2026_23_10_02_5.webp?v=1789161130&width=120' }
      ]
    },
    {
      products: [
        { handle: 'lampe-de-chevet-champignon-petite-bois-foncee', name: 'Bruna', color: '#4A2E1C' },
        { handle: 'lampe-de-chevet-champignon-petite-en-bois-claire', name: 'Biondina', color: '#D9B77C' }
      ]
    },
    {
      products: [
        { handle: 'lampe-de-chevet-cone-en-noyer', name: 'Conetta', color: '#5A3A28', image: 'https://cdn.shopify.com/s/files/1/1050/4755/6445/files/ChatGPT_Image_22_aout_2026_16_45_45_2_953ea246-3041-4a8d-8102-43806d6fdfd8.webp?v=1789560958&width=120' },
        { handle: 'lampe-de-chevet-boule-en-noyer', name: 'Sferica', color: '#6B4A32', image: 'https://cdn.shopify.com/s/files/1/1050/4755/6445/files/ChatGPT_Image_22_aout_2026_17_02_31_1_40db8a38-7e74-4358-99bb-1124fef054e4.webp?v=1789561841&width=120' }
      ]
    },
    {
      products: [
        { handle: 'lampe-de-chevet-marbre-style-classique', name: 'Marmora', color: '#D9D3C8', image: 'https://cdn.shopify.com/s/files/1/1050/4755/6445/files/ChatGPT_Image_22_aout_2026_17_12_10_6_f0aabc9e-e08a-458b-a7ea-06e36b25fe7d.webp?v=1789562976&width=120' },
        { handle: 'lampe-de-chevet-ancienne-pierre-verte', name: 'Smeraldina', color: '#1F5C3E', image: 'https://cdn.shopify.com/s/files/1/1050/4755/6445/files/ChatGPT_Image_27_aout_2026_19_23_21_1_1549e35f-24a1-4e81-ba73-03e69f316648.webp?v=1789563570&width=120' }
      ]
    },
    {
      products: [
        { handle: 'lampe-de-chevet-en-bambou-foncee-abat-jour-beige', name: 'Bambusa', color: '#5C4033' },
        { handle: 'lampe-de-chevet-en-bois-noir-abat-jour-beige', name: 'Laccata', color: '#1A1A1A' },
        { handle: 'lampe-de-chevet-en-structure-bois-clair-abat-jour-beige', name: 'Betulla', color: '#D4B896' }
      ]
    },
    {
      products: [
        { handle: 'lampe-de-chevet-blanche-doree-abat-jour-plisse', name: 'Perlacea', color: '#F5F3EE' },
        { handle: 'lampe-de-chevet-noir-doree-abat-jour-plisse', name: 'Ebano', color: '#1A1A1A' },
        { handle: 'lampe-de-chevet-rose-doree-abat-jour-plisse', name: 'Peonia', color: '#F1A9C1' }
      ]
    },
    {
      products: [
        { handle: 'lampe-de-chevet-wadi-sabi-noir-abat-jour-beige', name: 'Ossidiana', color: '#221F1C' },
        { handle: 'lampe-de-chevet-beige-wadi-sabi-beige-abat-jour-beige', name: 'Sabbia', color: '#E8DFC8' }
      ]
    },
    {
      products: [
        { handle: 'lampe-de-chevet-blanc-modele-simple-abat-jour-blanc-tissu', name: 'Ombretta', color: '#F2F0EA' },
        { handle: 'lampe-de-chevet-noir-modele-simple-abat-jour-noir-tissu', name: 'Carbonio', color: '#1E1E1E' }
      ]
    },
    {
      products: [
        { handle: 'lampe-de-chevet-citrouille-verre-blanc-metal', name: 'Niveo', color: '#F5F2EA' },
        { handle: 'lampe-de-chevet-citrouille-verre-orange-metal', name: 'Arancio', color: '#D98B3F' }
      ]
    },
    {
      products: [
        { handle: 'lampe-de-chevet-marbre-blanc-gris-style-minimaliste-abat-jour-blanc', name: 'Grisaille', color: '#D8D5D0' },
        { handle: 'lampe-de-chevet-marbre-beige-style-minimaliste-abat-jour-beige', name: 'Travertella', color: '#C7B592' },
        { handle: 'lampe-de-chevet-en-marbre-blanc-noir-style-minimaliste-abat-jour-blanc-casse', name: 'Contrasto', color: '#26232A' }
      ]
    }
  ];

  function handleFromUrl(url) {
    if (!url) return null;
    var m = url.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function currentHandle() {
    return handleFromUrl(window.location.pathname);
  }

  function findGroup(handle) {
    for (var i = 0; i < GROUPS.length; i++) {
      var group = GROUPS[i];
      for (var j = 0; j < group.products.length; j++) {
        if (group.products[j].handle === handle) return group;
      }
    }
    return null;
  }

  function buildSwatchLinks(group, activeHandle, extraClass) {
    var wrap = document.createElement('div');
    wrap.className = 'scandi-swatches' + (extraClass ? ' ' + extraClass : '');
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', 'Choisir une couleur');

    group.products.forEach(function (p) {
      var a = document.createElement('a');
      a.href = '/products/' + p.handle;
      a.className = 'scandi-swatch' + (p.image ? ' scandi-swatch--image' : '') + (p.handle === activeHandle ? ' scandi-swatch--selected' : '');
      if (p.image) {
        a.style.backgroundImage = 'url(' + p.image + ')';
      } else {
        a.style.setProperty('--swatch-color', p.color);
      }
      a.setAttribute('aria-label', p.name);
      if (p.handle === activeHandle) {
        a.setAttribute('aria-current', 'true');
      }
      wrap.appendChild(a);
    });

    return wrap;
  }

  function initProductPage() {
    var handle = currentHandle();
    var group = findGroup(handle);
    if (!group) return;

    document.querySelectorAll('.product-section__product-info').forEach(function (info) {
      if (info.querySelector('.scandi-swatches')) return;
      var badges = info.querySelector('.badges');
      if (!badges) return;
      badges.insertAdjacentElement('afterend', buildSwatchLinks(group, handle));
    });
  }

  function initProductCards() {
    document.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      var handle = handleFromUrl(link.getAttribute('href'));
      if (!handle) return;
      var group = findGroup(handle);
      if (!group) return;

      var card = link.closest('.product-card');
      if (!card) return;
      if (card.querySelector('.scandi-swatches')) return;

      var slot = card.querySelector('product-card-swatches');
      var swatches = buildSwatchLinks(group, handle, 'scandi-swatches--card');

      if (slot) {
        slot.appendChild(swatches);
      } else {
        var priceContainer = card.querySelector('.product-price-container');
        if (!priceContainer) return;
        priceContainer.insertAdjacentElement('afterend', swatches);
      }
    });
  }

  function initRecommendationNames() {
    document.querySelectorAll('.product-recommendations .product-card-group[data-short-name]').forEach(function (group) {
      if (group.querySelector('.reco-name-row')) return;

      var shortName = group.dataset.shortName;
      if (!shortName) return;

      var price = group.querySelector('product-price');
      if (!price) return;

      var row = document.createElement('div');
      row.className = 'reco-name-row';

      var nameEl = document.createElement('span');
      nameEl.className = 'reco-name';
      nameEl.textContent = shortName;

      row.appendChild(nameEl);
      row.appendChild(price);

      group.insertBefore(row, group.firstChild);
    });
  }

  function initHomeMosaicCardNames() {
    document.querySelectorAll('[id$="custom_section_697wno"] .product-card-group[data-short-name]').forEach(function (group) {
      if (group.querySelector('.home-mosaic-name-row')) return;

      var nameEl = group.querySelector('.text-block');
      var price = group.querySelector('product-price');
      if (!nameEl || !price) return;

      var row = document.createElement('div');
      row.className = 'home-mosaic-name-row';
      row.appendChild(nameEl);
      row.appendChild(price);

      group.insertBefore(row, group.firstChild);
    });
  }

  function init() {
    initProductPage();
    initProductCards();
    initRecommendationNames();
    initHomeMosaicCardNames();
  }

  init();

  var observer = new MutationObserver(function () {
    initProductCards();
    initRecommendationNames();
    initHomeMosaicCardNames();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
